module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":{"title":"List Selection"},"buttons":{"cancel":"Cancel"}},"es":{"header":{"title":"Seleccionar Lista"},"buttons":{"cancel":"Cancelar"}}}')
  delete Component.options._Ctor
}
